import className from 'classnames/bind';
import { motion } from 'motion/react';
import { Button } from '@components';
import { PressReleasesQuery } from '@graphqlTypes';

import styles from './ListingPressReleases.module.scss';
import { forwardRef, useMemo } from 'react';
import { formatDate } from '@/core/utils';
const cx = className.bind(styles);

type ListingPressReleasesItemProps = PressReleasesQuery['pressReleases']['nodes'][number];

const ListingPressReleasesItem = forwardRef<HTMLDivElement, ListingPressReleasesItemProps>(({ title, uri, pressReleaseFields }, ref) => {
  const { publishDate } = pressReleaseFields || {};
  const pillCopy = useMemo(() => publishDate ? formatDate(publishDate) : null, [publishDate]);
  return (
    <div className={cx("listing-press-releases-item")} ref={ref}>
      <div className={cx("copy")}>
        <h3 className={cx("title", "title-lc-m")}>{title}</h3>
        <span className={cx(["date", "pill"])}>{pillCopy}</span>
        <Button className={cx("cta")} label="details" url={uri} />
      </div>
      <span className={cx(["date", "pill"])}>{pillCopy}</span>
    </div>
  )
});

export default motion.create(ListingPressReleasesItem);